export default __webpack_public_path__ + "static/media/tortoise.aed1c6b9.png";